<template>
  <div class="bg" :style="{backgroundImage:bgImg}">
    <div v-if="$route.meta.fullPage" style="height: 100%">
      <div style="background-color: #fff">
        <div class="w1180">
        <el-row type="flex" align="middle" justify="space-around">
          <el-col :span="18">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: center">
              <el-image src="https://www.huayitraveltd.com/img/logo.png" fit="contain" style="width: 200px" v-if="true" />
              <el-image src="https://www.huayitraveltd.com/weblogo.png" fit="contain" style="width: 200px" v-else />
              <el-menu :default-active="activeIndex" ref="hdMenu" class="headerMenu" mode="horizontal" router style="margin-left: 15px" >
                <el-menu-item index="Index" route="/">{{ $t("header.index") }}</el-menu-item>
                <el-menu-item index="HotelList" route="/hotel/list">{{ $t("header.hotel") }}</el-menu-item>
                <el-menu-item index="TicketList" route="/ticket/list">{{ $t("header.ticket") }}</el-menu-item>
                <el-menu-item  @click="xianlu">{{ $t("header.tour") }}</el-menu-item>
                <el-menu-item index="CruiseList" route="/cruise/list" v-if="this.activeIndex === '12333'">{{ $t("header.yl") }}</el-menu-item>
                <el-menu-item index="DomesticList" route="/domestic/list">{{ $t("header.gntp") }}</el-menu-item>
              </el-menu>
            </div>
          </el-col>
          <el-col :span="9">
            <div style="display: flex;flex-direction: row;flex-wrap: nowrap;align-items: center;justify-content: end;">
              <el-dropdown @command="handleLangChange" size="medium" style="margin-right: 15px;cursor: pointer">
              <span class="el-dropdown-link">
              {{lang}}<i class="el-icon-arrow-down el-icon--right" />
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="zhCN">简体</el-dropdown-item>
                  <el-dropdown-item command="zhHK">繁體</el-dropdown-item>
                  <el-dropdown-item command="en">ENG</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown size="medium" style="margin-right: 15px;cursor: pointer" @command="handleCurrencyChange">
              <span class="el-dropdown-link" >
              {{$t('util.bz')}}:{{Vcurrency}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item v-for="(val,key) in currencyList" :key="key" :command="val" :disabled="VuserType === 'B2B' && val !== Vcurrency">{{val}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-popover
                placement="bottom"
                title=""
                width="300"
                trigger="hover"
                style="margin-right: 15px;cursor: pointer"
              >
                <div style="padding: 10px 0;">
                  <!-- WhatsApp 服务 -->
                  <div style="margin-bottom: 20px;">
                    <div style="display: flex; flex-direction: column; gap: 8px;">
                      <a
                        href="https://api.whatsapp.com/send/?phone=85366695342"
                        target="_blank"
                        style="display: inline-block; color: #42b983; text-decoration: underline; font-size: 14px;"
                      >
                        📱 Whatsapp 報名與查詢
                      </a>
                      <a
                        href="https://api.whatsapp.com/send/?phone=85363220969"
                        target="_blank"
                        style="display: inline-block; color: #42b983; text-decoration: underline; font-size: 14px;"
                      >
                        📱 Whatsapp 專人服務
                      </a>
                    </div>
                  </div>

                  <!-- 分隔线 -->
                  <hr style="border: none; border-top: 1px solid #eee; margin: 15px 0;">

                  <!-- 联系电话 -->
                  <div style="margin-bottom: 20px;">
                    <div style="font-weight: bold; color: #333; margin-bottom: 10px; font-size: 14px;">
                      📞 聯絡電話
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 6px; font-size: 13px; color: #666;">
                      <div>🇭🇰 香港: +852 27369189</div>
                      <div>🇲🇴 澳門: +853 28270189</div>
                      <div>🇨🇳 珠海: +86 07568868106</div>
                    </div>
                  </div>

                  <!-- 办公地址 -->
                  <div>
                    <div style="font-weight: bold; color: #333; margin-bottom: 10px; font-size: 14px;">
                      📍 辦公地址
                    </div>
                    <div style="display: flex; flex-direction: column; gap: 8px; font-size: 13px; color: #666; line-height: 1.4;">
                      <div>
                        <strong style="color: #333;">香港:</strong><br>
                        香港九龍尖沙咀麼地道75號南洋中心第1座3樓301B室
                      </div>
                      <div>
                        <strong style="color: #333;">澳門:</strong><br>
                        澳門羅保博士街1-3號澳門國際銀行大廈15樓C室
                      </div>
                      <div>
                        <strong style="color: #333;">珠海:</strong><br>
                        珠海香洲區粵海中路森宇富通大廈20樓2001室
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="reference" style="font-size: 14px">
                  <i class="el-icon-phone-outline" ></i>{{$t('util.llwm')}}
                </div>
              </el-popover>
              <el-divider direction="vertical" ></el-divider>
              <usr-box ref="UserBox"/>
            </div>
          </el-col>
        </el-row>
        </div>
      </div>
      <slot />
      <div style="background-color: #fff;height: auto;box-sizing: border-box;padding:25px 0;border-top: solid 1px #eeeeee;">
        <div class="w1180">
          <el-row justify="space-between" align="middle" type="flex">
            <el-col :span="12">
              <el-image fit="contain" style="width: 400px" src="https://www.huayitraveltd.com/img/color.logo.png" />
            </el-col>
            <el-col :span="12">
              <el-row type="flex" justify="end" class="footMenu">
                <el-col :span="8">
                  <label>HUAYI TRAVEL</label>
                  <ul>
                    <li><router-link to="/article/2">{{$t('util.gywm')}}</router-link></li>
                    <li><router-link to="/article/3">{{$t('util.tkxz')}}</router-link></li>
                    <li><a href="https://tour.huayitraveltd.com/appDown/#/" target="_blank">{{$t('util.mee')}}</a></li>
                    <li><a href="https://image.huayitraveltd.com/HongKongHuayiTravelDistributionCooperationAgreement.pdf" target="_blank">{{$t('util.Agreement')}}</a></li>
                  </ul>
                </el-col>
                <el-col :span="8">
                  <label >{{$t('util.lxwm')}}</label>
                  <ul>
                    <li><router-link to="/article/26">{{$t('util.khfwzy')}}</router-link></li>
                    <li><router-link to="/article/32">{{$t('util.jrwm')}}</router-link></li>
                  </ul>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-row type="flex" align="middle" justify="center" class="foot">
        <el-col :span="24">CopyRight©2010~2023 huayitraveltd.com {{$t('util.bqsy')}}  |  <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备19153240号-1</a></el-col>
      </el-row>
    </div>
    <slot v-else />
    <el-backtop :bottom="130">
      <div
        style="height: 100%; width: 100%; text-align: center; color: #1989fa;"
      ><i class="el-icon-top" /></div>
    </el-backtop>
    <el-backtop :bottom="80" >
      <div
        @click.stop="handleDownApp"
        style="height: 100%; width: 100%; font-size: 14px; text-align: center; color: #1989fa;"
      >APP</div>
    </el-backtop>
  </div>
</template>

<script>
import {currencyList} from '../../service/util'
import UsrBox from './usrBox'
var ctx
export default {
  name: 'hy-layout',
  components: {UsrBox},
  data () {
    return {
      bgImg: '',
      activeIndex: 'Index',
      currencyList: []
    }
  },
  watch: {
    '$route.path': {
      handler (v) {
        console.log('当前路由路径:', v)
        if (v) {
          const rootPath = v.split('/')[1] || '' // 提取根路径（如 /detail/291 提取出 'detail'）
          let activeIndex = ''

          // 根据根路径匹配对应菜单的 index
          if (rootPath === '') {
            activeIndex = 'Index' // 首页
          } else if (rootPath === 'hotel') {
            activeIndex = 'HotelList' // 酒店
          } else if (rootPath === 'ticket') {
            activeIndex = 'TicketList' // 门票
          } else if (rootPath === 'tour') {
            activeIndex = 'TourList' // 线路
          } else if (rootPath === 'cruise') {
            activeIndex = 'CruiseList' // 邮轮
          } else if (rootPath === 'domestic' || rootPath === 'detail') {
            // 关键修改：套票列表（/domestic/list）和套票详情（/detail/291）都选中套票菜单
            activeIndex = 'DomesticList'
          }

          this.activeIndex = activeIndex
          console.log('当前选中的菜单index:', this.activeIndex)
        }
      },
      immediate: true // 初始化时立即执行一次
    }
  },
  created () {
    this.$EventBus.$on('loginRequest', this.requestLogin)
  },
  mounted () {
    this.refReady('hdMenu').then(ref => {
      ref.activeIndex = this.activeIndex
    })

    currencyList().then(res => {
      if (res.code === 200) {
        this.currencyList = res.data
      }
    })
    if (this.VuserType === 'B2B' && this.VcompanyInfo && this.VcompanyInfo.currency) {
      if (this.Vcurrency !== this.VcompanyInfo.currency) {
        this.handleCurrencyChange(this.VcompanyInfo.currency)
      }
    }
  },
  destroyed () {
    if (ctx) clearTimeout(ctx)
    this.$EventBus.$off('loginRequest')
  },
  computed: {
    lang () {
      const locale = this.$i18n.locale
      if (locale === 'zhCN') {
        return '简体'
      } else if (locale === 'zhHK') {
        return '繁體'
      } else {
        return 'ENG'
      }
    }
  },
  methods: {
    refReady (ref) {
      if (ctx) clearTimeout(ctx)
      return new Promise(resolve => {
        if (typeof this.$refs[ref] !== 'undefined') {
          resolve(this.$refs[ref])
        } else {
          ctx = setTimeout(() => {
            return this.refReady(ref)
          }, 10)
        }
      })
    },
    requestLogin () {
      this.$refs.UserBox.fnHandleLogin()
    },
    handleLangChange (e) {
      this.setLang(e)
      this.$i18n.locale = e
      // 切换Element UI的语言
      this.$changeElementUILocale(e)
      window.location.reload()
    },
    handleCurrencyChange (e) {
      this.setCurrency(e)
      window.location.reload(-1)
    },
    handleDownApp () {
      window.location.href = 'https://tour.huayitraveltd.com/appDown/#/'
    },
    xianlu () {
      window.location.href = 'https://t.huayitraveltd.com/routes'
    }
  }
}
</script>
<style>
.el-backtop{
  z-index: 12;
}
</style>
<style scoped lang="scss">
.foot{
  background: #1a1a1a;
  color: #fff;
  & a{
    color: #fff;
  }
}
.bg{
  display: inline-block;
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.footMenu{
  & label{
    font-size: 16px;
    font-weight: 700;
  }
  & p{
    margin:5px 0;
    font-size: 14px;
    color: #2e2e2e;
  }
  & ul,
  & ul li{
    list-style: none;
    margin:0;
    padding: 0;
  }
  & ul li{
    font-size: 14px;
    margin: 5px 0 5px 8px;
    & a:hover{
      text-decoration: underline !important;
    }
    & a{
      cursor: pointer;
      color: #3264ff;
      text-decoration: none;
    }
  }
}
.headerMenu{
  border-bottom: none !important;

  & .el-menu-item{
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/hy-layout.vue